import React, { useState } from "react";
import "./referPage.css";
import { useNavigate } from "react-router-dom";
import { Select, message } from "antd";
import AxiosInstance from "../../../AxiosInstance";

import { Controller, useForm } from "react-hook-form";
import { useMediaQuery } from "react-responsive";
import OtherPageHeader from "../../../components/OtherHeader";
import { Option } from "antd/es/mentions";
import { useEffect } from "react";
import { alertSuccess } from "../../Helper/Alerts";
import ToastNotification from "../../../feature/ToastNotification";

export default function ReferPage() {
  useEffect(() => {
    setValue("countryCode", "+91");
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    reset,
  } = useForm({ mode: "onChange" });
  const navigate = useNavigate();
  const [panDoc, setpanDoc] = useState();
  const [aadharDoc, setaadharDoc] = useState();
  const [cancelledChecqDoc, setcancelledChecqDoc] = useState();

  async function handleDocument(event, target) {
    switch (target) {
      case "pan":
        setpanDoc(event.target.files[0]);
        break;
      case "aadhar":
        setaadharDoc(event.target.files[0]);
        break;
      default:
        setcancelledChecqDoc(event.target.files[0]);
        break;
    }
  }

  async function uploadDocumentToAWS(file) {
    const url = "/common/upload-policy-document";
    const formData = new FormData();
    formData.append("file", file);

    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    try {
      let response = await AxiosInstance().post(url, formData, config);
      return response.data["policyContractFileName"];
    } catch (e) {
      return "";
    }
  }
  const roleChange = (value, data) => {
    errors.role = false;
    setValue("role", data.value);
  };

  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });

  const onSubmit = async (value) => {
    AxiosInstance()
      .post("/partner/referral", value)
      .then((resp) => {
        if (resp.status === 201) {
          alertSuccess("User Added Successfully");
          window.location.href = "/partnerdashboard";
        }
      })
      .catch((err) => {
        message.error(err.response.data.message);
      });
  };

  return (
    <div>
      <OtherPageHeader
        classProps="bg-transparent"
        innerClassProps="bg-transparent"
      />

      <div className="leftDiv-complete-refer">
        <div className="common-width">
          <button
            type="submit"
            title="back-button"
            className="back-button mt-3 mb-4"
            onClick={() => navigate(-1)}
          >
            {" "}
            <i className="fa fa-angle-left" /> Back
          </button>
          <h2>Refer a Profile</h2>

          <form id="completePHDetailsForm" onSubmit={handleSubmit(onSubmit)}>
            <div className={`form-group ${isMobile ? "" : "col-7"}`}>
              <label htmlFor="firstName">Type of User</label>
              <div className="input-group pb-3">
                <Controller
                  name="role"
                  control={control}
                  errors={errors}
                  rules={{ required: true }}
                  render={(props) => (
                    <Select
                      placeholder="Select User Role"
                      className={`${errors.role ? "is-invalid" : ""}`}
                      onChange={roleChange}
                      size="large"
                      style={{ width: "100%" }}
                    >
                      <Option key={"INVESTOR"} value={"INVESTOR"}>
                        INVESTOR
                      </Option>
                      <Option key={"POLICY_MASTER"} value={"POLICY_MASTER"}>
                        POLICY HOLDER
                      </Option>
                      <Option key={"PARTNER"} value={"PARTNER"}>
                        PARTNER
                      </Option>
                    </Select>
                  )}
                />
                <div className="invalid-feedback">User Role is required</div>
              </div>

              <label htmlFor="firstName">First Name</label>
              <div className="input-group pb-3">
                <input
                  id="firstName"
                  type="text"
                  maxlength="30"
                  className={`form-control ${
                    errors.firstName ? "is-invalid" : ""
                  }`}
                  placeholder="First Name"
                  {...register("firstName", { required: true })}
                />
                <div className="invalid-feedback">First Name is required</div>
              </div>
              <label htmlFor="lastName">Last Name</label>
              <div className="input-group pb-3">
                <input
                  type="text"
                  id="lastName"
                  maxlength="30"
                  className={`form-control ${
                    errors.lastName ? "is-invalid" : ""
                  }`}
                  placeholder="Last Name"
                  {...register("lastName", { required: true })}
                />
                <div className="invalid-feedback">Last Name is required</div>
              </div>

              <label htmlFor="email">Email Address</label>
              <div className="input-group pb-3">
                <input
                  type="email"
                  className={`form-control ${errors.email ? "is-invalid" : ""}`}
                  id="email"
                  placeholder="Email Address"
                  {...register("email", {
                    required: true,
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "invalid email address",
                    },
                  })}
                />
                <div className="invalid-feedback">
                  Email Address is required
                </div>
              </div>
              <label htmlFor="email">Mobile Number </label>
              <div className={`input-group mb-3 `}>
                <select
                  className="form-select form-select-sm  countryCode"
                  aria-label=".form-select-sm Default select example"
                  onChange={(data) => {
                    setValue("countryCode", data.target.value);
                  }}
                >
                  <option value="+91" defaultValue>
                    +91
                  </option>
                  <option value="+92">+92</option>
                  <option value="2">+93</option>
                  <option value="3">+94</option>
                </select>
                <input
                  id="phoneNumber"
                  type="text"
                  pattern="[0-9]*"
                  inputMode="numeric"
                  className={`form-control mobileField${
                    errors.phoneNumber ? " is-invalid" : ""
                  }`}
                  maxLength={10}
                  minLength={10}
                  aria-label="Text input with dropdown button"
                  {...register("phoneNumber", {
                    required: true,
                    pattern: {
                      value: /^(\+?\d{1,4}[\s-])?(?!0+\s+,?$)\d{10}\s*,?$/i,
                      message: "invalid mobile number",
                    },
                  })}
                />

                <div className="invalid-feedback">
                  mobile number is required
                </div>
              </div>
            </div>
          </form>
          <button
            className="normal-button-refer mb-5 px-3 py-2"
            form="completePHDetailsForm"
          >
            Register Profile
          </button>
        </div>
      </div>
      {!isMobile && (
        <div className="rightDiv-complete-ph-profile">
          <div className="common-width">
            <img src="assets/g8.jpg" width="50%" alt="" />
          </div>
        </div>
      )}
    </div>
  );
}
